<template>
<div class="chapter">
<div class="inner_page">
<p class="fst"><em>Praise for KAREN HAWKINS…</em></p>
<p class="fsq"><a id="page_ii">“Always funny and sexy, a Karen Hawkins book is a sure delight!”</a></p><a id="page_ii">
<p class="fsc">—Victoria Alexander</p>
<p class="fsq">“Karen Hawkins writes fast, fun, and sexy stories that are a perfect read for a rainy day, a sunny day, or any day at all!”</p>
<p class="fsc">—Christina Dodd</p>
<p class="fsq">“Karen Hawkins will make you laugh and touch your heart.”</p>
<p class="fsc">—Rachel Gibson</p>
<p class="fst"><em>… and her sparkling historical romances featuring the MacLeans</em></p>
<p class="fst1"><em>THE LAIRD WHO LOVED ME</em></p>
<p class="fsq">“Readers who met Caitlyn in <em>Sleepless in Scotland</em> will applaud her return.… The story is filled with biting repartee, humor, and sexual tension that will keep you turning the pages with glee.”</p>
<p class="fsc">—<em>Romantic Times</em> (4½ stars, Top Pick)</p>
<p class="fsq">“Delightful in every way.”</p>
<p class="fsc">—Reader To Reader</p>
<p class="fst"><em>SLEEPLESS IN SCOTLAND</em></p>
<p class="fsq">“Amusing yet profound.… Readers will be sleepless in America due to a one-sitting enjoyable time.”</p>
<p class="fsc">—Harriet Klausner</p>
<p class="fsq">“Delightfully humorous, poignant, and highly satisfying novels: that’s what Hawkins always delivers.”</p>
</a><p class="fsc"><a id="page_ii"></a><a id="page_iii">—<em>Romantic Times</em> (4½ stars)</a></p><a id="page_iii">
<p class="fst"><em>TO CATCH A HIGHLANDER</em></p>
<p class="fsq">“Love and laughter, poignancy and emotional intensity, endearing characters, and a charming plot are the ingredients in Hawkins’s utterly delightful tale.”</p>
<p class="fsc">—<em>Romantic Times</em></p>
<p class="fsq">“Karen Hawkins’s best book to date! Fast, sensual, and brilliant, it tantalizes and pleases all in the same breath.… This is romance at its best!”</p>
<p class="fsc">—Romance and More</p>
<p class="fst"><em>TO SCOTLAND, WITH LOVE</em></p>
<p class="fsq">“Hawkins bring another hardheaded MacLean brother and a sassy miss together in a sensual battle of the sexes. Her humor, intelligent characters, and story are simply delightful.”</p>
<p class="fsc">—<em>Romantic Times</em></p>
<p class="fst"><em>HOW TO ABDUCT A HIGHLAND LORD</em></p>
<p class="fsq">“Hawkins takes a fiery Scot lass and a wastrel lord and puts them together in a match made in, well, not heaven, but one that’s heated, exciting, and touching. Hawkins excels at taking tried-and-true plotlines and turning them into fresh, vibrant books.”</p>
<p class="fsc">—<em>Romantic Times</em></p>
<p class="fsq">“In <em>How to Abduct a Highland Lord,</em> the characters are as wonderful as the story.… [It] is laced with passion and drama, and with its wonderfully romantic and thrilling ending, it’s a story you don’t want to miss!”</p>
<p class="fsc">—Joyfully Reviewed</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001.vue?1ee3c421